import React from 'react'
import moment from "moment";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import "./linkRegister.css";
import CompanySVGComponent from '../../Components/Common/SVGComponents/CompanySVGComponent';
import commoncss from "../../myfin_v2/css/common.module.css";
import linkRegcss from "../../myfin_v2/css/linkReg.module.css";
import {ReactComponent as DropDownIcon} from "../../myfin_v2/assets/icons/down_arrow.svg";
import {ReactComponent as CalendarIcon} from "../../myfin_v2/assets/icons/calenderIcon.svg";
import {ReactComponent as WarningIcon} from "../../myfin_v2/assets/icons/warningIconGrey.svg";

const LinkRegisterAccordion = ({ setSelectedItems, selectedItems, name, data, setDraggedData, searchValue }) => {

    const filteredData = data?.filter((ele) => {
        if (!searchValue) return true;
        const search = searchValue.toLowerCase();
        return (
            (ele?.name && ele.name.toLowerCase().includes(search)) ||
            (ele?.companyData?.company_name && ele.companyData.company_name.toLowerCase().includes(search))
        );
    });

    const handleCheckboxChange = (id) => {
        const isSelected = selectedItems.includes(id);

        if (isSelected) {
            setSelectedItems(selectedItems.filter(item => item !== id));
        } else {
            setSelectedItems([...selectedItems, id]);
        }
    };

    const handleDragStart = (e, ele, name) => {
        if (selectedItems.length > 0) {
            const filterSelectedData = data.filter(data_ele => selectedItems.includes(data_ele._id))
            setDraggedData(filterSelectedData.map(d => ({ data: d, name })));
        } else {
            setDraggedData([{ data: ele, name }]);
        }
    };

    if (searchValue && (!filteredData || filteredData.length === 0)) {
        return null;
    }

    return (
        <>
            <Accordion disableGutters elevation={0} sx={{ '&:before': { display: 'none' } }}>
                <AccordionSummary
                    className="d-flex px-2 bg-white px-3"
                    //expandIcon={<ArrowDropDownIcon />}
                    expandIcon={<DropDownIcon/>}
                    style={{ minHeight: '40px', margin: 0 }}
                >
                    <Typography className={`custom-font-400 font-size-14 text-dark ${linkRegcss.accordionTitle}`} style={{ margin: 0 }} >{name}</Typography>
                </AccordionSummary>
                <AccordionDetails className='custom-bg-white' style={{ paddingTop: "0px", paddingBottom: "20px" }}>
                    {
                        filteredData?.length > 0 ?
                            filteredData.map(ele => (
                                <div
                                    key={ele._id}
                                    draggable
                                    onDragStart={(e) => handleDragStart(e, ele,name)}
                                    className={`d-flex mt-2 p-2 bg-white cursor-pointer radius-8px ${
                                        selectedItems.includes(ele._id) 
                                            ? linkRegcss.importCardSelected 
                                            : linkRegcss.importCardUnselected
                                    }`}
                                
                                        
                                >
                                    <input
                                        className={`cursor-pointer me-2 ${linkRegcss.checkboxAdjust}`}
                                        type="checkbox"
                                        checked={selectedItems.includes(ele._id)}
                                        onChange={() => handleCheckboxChange(ele._id)}
                                    />
                                    <div>
                                        <p className="m-0 p-0 font-size-14 text-black-400 font-inter font-weight-normal ml-1"  style={{ color: "#162F28" }}>{`${ele?.name}`}</p>
                                        <p className="m-0 p-0 font-size-12 text-color d-flex justify-content-center align-items-center custom-font-400 font-inter" style={{color: "#809790"}}>
                                            {/* <CompanySVGComponent color={"#ABA9A9"} width={11} height={15} /> */}
                                            <span className='ml-1 mt-1' >{ele?.companyData?.company_name || "NA"}</span>
                                            <CalendarIcon className="ml-4" style={{ height: "15px", marginBottom: "3px"}} />
                                            <span style={{paddingLeft: "4px"}}>
                                                {
                                                    name === "Leases" ?
                                                        ele?.createdAt && moment(ele?.createdAt).format("MMMM DD YYYY")
                                                        : name === "Loans" ?
                                                            ele?.endDate && moment(ele?.endDate).format("MMMM DD YYYY"): 
                                                            ['Payable', 'Receivables'].includes(name) ?
                                                            ele?.asOnDate && moment(ele?.asOnDate).format("MMMM DD YYYY")
                                                            : ele?.createdAt && moment(ele?.createdAt).format("MMMM DD YYYY")
                                                }
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            ))
                            : <p className="m-0 p-0 text-secondary text-center" style={{ fontSize: "12px"}}><WarningIcon  style={{ paddingRight: "3px" }}/> {"No Registers Available"} </p>
                    }
                </AccordionDetails>
            </Accordion>
        </>
    )
}

export default LinkRegisterAccordion